import React from 'react';
import { Handle, Position } from '@xyflow/react';

export default function RunJsNode({ data, selected }) {
  return (
    <div
      className={data?.__animateAppear ? 'workflow-node-appear' : undefined}
      style={{
        padding: '10px 14px',
        background: 'var(--card-bg)',
        border: selected ? '2px solid #8b5cf6' : '1px solid #8b5cf6',
        borderRadius: '8px',
        minWidth: 120,
        boxShadow: selected ? '0 0 0 2px rgba(139, 92, 246, 0.35)' : '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <Handle type="target" position={Position.Left} style={{ background: '#8b5cf6', width: 14, height: 14, borderRadius: '50%' }} />
      <div style={{ fontWeight: 600, marginBottom: 4, color: 'var(--text-primary)' }}>Run JS</div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>{data?.label ?? 'JavaScript'}</div>
      <Handle type="source" position={Position.Right} style={{ background: '#8b5cf6', width: 14, height: 14, borderRadius: '50%' }} />
    </div>
  );
}
